import { ChangeDetectorRef, Injectable } from '@angular/core';

import { CompanyForm } from '@companies/config/enums/company-form';
import { DashboardsAbstract } from '@dashboards/components/abstract/dashboards.abstract';
import { RestCompanyModel } from '@shared/interfaces/companies.interface';

@Injectable()
export abstract class CompaniesAbstract extends DashboardsAbstract {
  isLoading = false;
  companyModel: RestCompanyModel;

  protected constructor(protected cdr: ChangeDetectorRef) {
    super(cdr);
  }

  get CompanyForm(): typeof CompanyForm {
    return CompanyForm;
  }
}
